module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Pencils-p-800-09785689415a3fb45e6e899875bed723.png";